import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import {first} from "rxjs/operators";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Page} from "../models/page";
import {Items} from "../models/items";
import {Service} from "../models/service";
import {DeleteServiceDialogComponent} from "../service/dialog/deleteServiceDialog.component";
import {FormGroup} from "@angular/forms";
import {DeleteUserDialogComponent} from "../user/dialog/deleteUserDialog.component";
import {User} from "../models";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute} from "@angular/router";

@Component({
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    filterValue: string;
    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;
    deleteDialogRef: any;
    from: string;
    to: string;
    firstSaleFrom: string;
    firstSaleTo: string;
    firstOnlineSaleFrom: string;
    firstOnlineSaleTo: string;
    firstTraditionalSaleFrom: string;
    firstTraditionalSaleTo: string;
    locale = 'pl';
    filters: any[];
    sort: any[] = [];
    selectedRegistrationSource: string | null = null;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        public _matDialog: MatDialog,
        private route: ActivatedRoute,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 20;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');

        if (this.route.snapshot.params['from'] && this.route.snapshot.params['to']) {
            this.from = this.route.snapshot.params['from'];
            this.to = this.route.snapshot.params['to'];
        }

        if (this.route.snapshot.params['firstSaleFrom'] && this.route.snapshot.params['firstSaleTo']) {
            this.firstSaleFrom = this.route.snapshot.params['firstSaleFrom'];
            this.firstSaleTo = this.route.snapshot.params['firstSaleTo'];
        }

        if (this.route.snapshot.params['firstOnlineSaleFrom'] && this.route.snapshot.params['firstOnlineSaleTo']) {
            this.firstOnlineSaleFrom = this.route.snapshot.params['firstOnlineSaleFrom'];
            this.firstOnlineSaleTo = this.route.snapshot.params['firstOnlineSaleTo'];
        }

        if (this.route.snapshot.params['firstTraditionalSaleFrom'] && this.route.snapshot.params['firstTraditionalSaleTo']) {
            this.firstTraditionalSaleFrom = this.route.snapshot.params['firstTraditionalSaleFrom'];
            this.firstTraditionalSaleTo = this.route.snapshot.params['firstTraditionalSaleTo'];
        }
    }

    ngOnInit() {
        this.sort['sortDir'] = 'ASC';
        this.sort['sortCol'] = 'lastName';

        this.setPage({ offset: 0 });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    public unsubscribe(): void {
        this._unsubscribeAll.next();
    }

    updateFilter(event) {
        this.unsubscribe();
        this.filterValue = event.target.value.toLowerCase();

        if (this.filterValue.length < 3) {
            return;
        }

        this.loadingIndicator = true;

        this.userService.getAllCustomersBy(this.filterValue).pipe(takeUntil(this._unsubscribeAll))
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.items.length;
                },
                error => {
                    this.alertService.error(error);
                })

        this.table.offset = 0;
    }

    sortResults(pageInfo) {
        this.rows = [];
        this.page.totalElements = 0;
        this.loadingIndicator = true;
        this.sort['sortDir'] = pageInfo.sorts[0].dir;
        this.sort['sortCol'] = pageInfo.sorts[0].prop;

        this.setPage({ offset: 0 });
    }

    setPage(pageInfo) {
        this.unsubscribe();
        this.loadingIndicator = true;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.filters = [];
        if (this.from && this.to) {
            this.filters['createdAt'] = this.from;
            this.filters['createdAtTo'] = this.to;
        } else if (this.firstSaleFrom && this.firstSaleTo) {
            this.filters['firstSaleFrom'] = this.firstSaleFrom;
            this.filters['firstSaleTo'] = this.firstSaleTo;
        } else if (this.firstOnlineSaleFrom && this.firstOnlineSaleTo) {
            this.filters['firstOnlineSaleFrom'] = this.firstOnlineSaleFrom;
            this.filters['firstOnlineSaleTo'] = this.firstOnlineSaleTo;
        } else if (this.firstTraditionalSaleFrom && this.firstTraditionalSaleTo) {
            this.filters['firstTraditionalSaleFrom'] = this.firstTraditionalSaleFrom;
            this.filters['firstTraditionalSaleTo'] = this.firstTraditionalSaleTo;
        }

        if (this.selectedRegistrationSource) {
            this.filters['registrationSource'] = this.selectedRegistrationSource;
        }

        this.userService.getAllCustomersPaged(pageInfo.offset * pageInfo.limit, pageInfo.limit, this.filters, this.sort).pipe(takeUntil(this._unsubscribeAll))
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    showConfirmUserDeleteDialog(user: User) {
        this.deleteDialogRef = this._matDialog.open(DeleteUserDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                user: user,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.userService.delete(user.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    filterByCategory(id: string|null) {
        // if (id !== null) {
        //     this.serviceService.getAllByCategory(id).subscribe((res: any[]) => {
        //         this.rows = res;
        //         this.loadingIndicator = false;
        //     }, error => {
        //         this.alertService.error(error);
        //     });
        // } else {
        //     this.findAll();
        // }
    }

    filterByRegistrationSource(source: string | null) {
        this.selectedRegistrationSource = source;
        this.setPage({ offset: 0 });
    }
}
